// ortsteilAbgleich.ts — Ortsteil beim Ändern der Anschrift (User 30.09.2026).
//
// Der Ortsteil kommt nur aus dem Google-Vorschlag (AddressAutocomplete) oder
// von Hand. Ändert jemand danach PLZ oder Ort — getippt, per „Daten befüllen"
// oder im Adress-Dialog —, blieb der alte Ortsteil stehen und passte nicht
// mehr zur Anschrift („80331 München, Sendling" wird „70173 Stuttgart,
// Sendling").
//
// Regel: Weicht PLZ oder Ort vom bisherigen Wert ab, wird der Ortsteil
// geleert. Ausnahme: Derselbe Vorgang setzt selbst einen Ortsteil (wie der
// Google-Vorschlag) — dann gilt dieser.

export interface OrtsteilStand {
  plz?: string | null;
  ort?: string | null;
  ortsteil?: string | null;
}

const norm = (v: string | null | undefined): string => (v ?? "").trim().toLowerCase();

/**
 * Der Ortsteil NACH einer Änderung.
 *
 * @param vorher  der bisherige Stand
 * @param aenderung  was der Vorgang setzt; `undefined` = Feld nicht berührt
 * @returns der neue Ortsteil (unverändert, geleert `""` oder der mitgelieferte)
 */
export function ortsteilNachAenderung(vorher: OrtsteilStand, aenderung: OrtsteilStand): string {
  if (aenderung.ortsteil !== undefined) return aenderung.ortsteil ?? "";
  const plzAnders = aenderung.plz !== undefined && norm(aenderung.plz) !== norm(vorher.plz);
  const ortAnders = aenderung.ort !== undefined && norm(aenderung.ort) !== norm(vorher.ort);
  return plzAnders || ortAnders ? "" : (vorher.ortsteil ?? "");
}

/** Muss der Ortsteil nach dieser Änderung geleert werden? */
export const ortsteilLeeren = (vorher: OrtsteilStand, aenderung: OrtsteilStand): boolean =>
  !!norm(vorher.ortsteil) && aenderung.ortsteil === undefined && ortsteilNachAenderung(vorher, aenderung) === "";
